export function getImageUrl(filePath: string, width: number, params: Record<string, string | undefined> = {}) {
  const normalizedPath = filePath.trim().replace(/\\/g, '/').replace(/^\/+/, '');
  const encodedPath = normalizedPath.split('/').filter(Boolean).map(encodeURIComponent).join('/');
  const searchParams = new URLSearchParams({ w: String(width) });

  Object.entries(params).forEach(([key, value]) => {
    if (value) searchParams.set(key, value);
  });

  return `/api/image/${encodedPath}?${searchParams.toString()}`;
}

const API_IMAGE_PREFIX = '/api/image/';

/** Grid layout widths: 1 column below 640px, 2 below 1024px, then 3. */
export const PHOTO_GRID_SIZES = '(max-width: 639px) 100vw, (max-width: 1023px) 50vw, 33vw';

/** The same /api/image URL at another width, or null when the URL isn't an /api/image URL. */
export function withImageWidth(url: string, width: number): string | null {
  if (!url.startsWith(API_IMAGE_PREFIX)) return null;
  const queryIndex = url.indexOf('?');
  const path = queryIndex === -1 ? url : url.slice(0, queryIndex);
  const searchParams = new URLSearchParams(queryIndex === -1 ? '' : url.slice(queryIndex + 1));
  searchParams.set('w', String(width));
  return `${path}?${searchParams.toString()}`;
}

/**
 * 400w/800w srcset for an 800px grid thumbnail. The 800w entry is the original URL,
 * unchanged, so the grid and the lightbox placeholder share one browser-cache entry.
 */
export function getThumbnailSrcSet(thumbnailSrc: string | undefined): string | undefined {
  if (!thumbnailSrc?.startsWith(API_IMAGE_PREFIX)) return undefined;
  const queryIndex = thumbnailSrc.indexOf('?');
  if (queryIndex === -1 || new URLSearchParams(thumbnailSrc.slice(queryIndex + 1)).get('w') !== '800') return undefined;
  const small = withImageWidth(thumbnailSrc, 400);
  return small ? `${small} 400w, ${thumbnailSrc} 800w` : undefined;
}
